import { extractLotameInterestsFromNowPlaying } from '../utils/ads/lotameUtils';
import { getFavoriteMessageText } from '../utils/getFavoriteMessageText';
import { sendLotameInterests } from './mint';
import { showMessage } from './messagePopover';
import makeFavoriteActions from './utils/makeFavoriteActions';

export const FAVORITE_CURRENTLY_PLAYING = 'FAVORITE_CURRENTLY_PLAYING';
export const UNFAVORITE_CURRENTLY_PLAYING = 'UNFAVORITE_CURRENTLY_PLAYING';
export const FAVORITE_CONTAINER_ITEM = 'FAVORITE_CONTAINER_ITEM';
export const UNFAVORITE_CONTAINER_ITEM = 'UNFAVORITE_CONTAINER_ITEM';
export const FAVORITE_PROFILE = 'FAVORITE_PROFILE';
export const UNFAVORITE_PROFILE = 'UNFAVORITE_PROFILE';

const endpoints = {
  [FAVORITE_CURRENTLY_PLAYING]: 'add',
  [UNFAVORITE_CURRENTLY_PLAYING]: 'remove',
  [FAVORITE_CONTAINER_ITEM]: 'add',
  [UNFAVORITE_CONTAINER_ITEM]: 'remove',
  [FAVORITE_PROFILE]: 'add',
  [UNFAVORITE_PROFILE]: 'remove',
};

/**
 * profile favorite actions
 */
export const {
  unFavorite: unFavoriteProfile,
  toggleFavorite: toggleProfileFavorite,
} = makeFavoriteActions({
  favoriteType: FAVORITE_PROFILE,
  unFavoriteType: UNFAVORITE_PROFILE,
});

/**
 * creates an action which makes the favorite call to the favorites api
 * @param type  - aciton type
 * @param guideId - guideId of the item being favorited/unfavorited
 * @param meta - metadata to be used in the reducer for this action
 * @returns {object}
 */
export const favoriteEffect = (type, guideId, meta) => {
  const endpoint = endpoints[type];

  return {
    type,
    api: {
      endpoint: ['favorites', endpoint],
      args: [guideId],
    },
    meta: {
      guideId,
      ...meta,
    },
  };
};

/**
 * favorite action used in the player for the currently playing item
 * @param guideId
 * @returns {Function}
 */
export function favoriteCurrentlyPlayingItem(guideId = '') {
  return (dispatch, getState) => {
    const { nowPlaying } = getState().player;
    const favoriteMessages = getFavoriteMessageText(guideId, getState());
    dispatch(
      sendLotameInterests(extractLotameInterestsFromNowPlaying(nowPlaying)),
    );
    dispatch(
      favoriteEffect(FAVORITE_CURRENTLY_PLAYING, guideId, { nowPlaying }),
    )
      .then(({ value: { status } }) => {
        if (status === 200) {
          dispatch(showMessage(favoriteMessages.favorited));
        } else {
          dispatch(showMessage(favoriteMessages.favoriteError));
        }
      })
      .catch(() => {
        dispatch(showMessage(favoriteMessages.favoriteError));
      });
  };
}

/**
 * unfavorite action used in the player for the currently playing item
 * @param guideId
 * @returns {Function}
 */
export function unFavoriteCurrentlyPlayingItem(guideId) {
  return (dispatch, getState) => {
    const { nowPlaying } = getState().player;
    const favoriteMessages = getFavoriteMessageText(guideId, getState());
    dispatch(
      favoriteEffect(UNFAVORITE_CURRENTLY_PLAYING, guideId, { nowPlaying }),
    )
      .then(({ value: { status } }) => {
        if (status === 200) {
          dispatch(showMessage(favoriteMessages.unFavorited));
        } else {
          dispatch(showMessage(favoriteMessages.unFavoriteError));
        }
      })
      .catch(() => {
        dispatch(showMessage(favoriteMessages.unFavoriteError));
      });
  };
}

/**
 * favorite action used to favorite a guideItem rendered in a container
 * @param guideId
 * @returns {Function}
 */
export function favoriteContainerItem({ guideId }) {
  return (dispatch) => {
    dispatch(favoriteEffect(FAVORITE_CONTAINER_ITEM, guideId));
  };
}

/**
 * unfavorite action used to favorite a guideItem rendered in a container
 * @param guideId
 * @returns {Function}
 */
export function unFavoriteContainerItem({ guideId }) {
  return (dispatch) => {
    dispatch(favoriteEffect(UNFAVORITE_CONTAINER_ITEM, guideId));
  };
}
